import React, { useState } from 'react';
import { ScrollView, View } from 'react-native';
import { BettorSearch, SocialComponents } from 'be-components';
import Colors from '../../constants/Colorsv2';
import { PublicPlayerProps } from '../../store/types/auth_svc';


const SearchScreen = ({ route, navigation }:any) => {
    const [ players, setPlayers ] = useState<PublicPlayerProps[]>([]);

    return (
        <View style={{flex:1, backgroundColor:Colors.shades.white}}>
            <ScrollView style={{ flex:1 }} showsVerticalScrollIndicator={false}>
                <BettorSearch
                    search_types={['players']}
                    init_search_value=' '
                    onSearchResults={(results) => {
                        setPlayers(results.players)
                    }}
                />
                <View style={{ padding:10 }}>
                    <SocialComponents.PlayerList
                        players={players}
                        options={{
                            follow_status:true,
                            direction:'horizontal'
                        }}
                        onPlayerSelect={(p) => navigation.navigate('SocialStack', { screen:'SocialProfile', initial:false, params: { player_id: p.player_id } })}
                    />
                </View>
            </ScrollView>
        </View>
    )
}

export default SearchScreen